import { plainToClass } from 'class-transformer';
import {
  API_NOTIFICATION_MESSAGE_CREATE,
  API_NOTIFICATION_MESSAGE_DELETE,
  API_NOTIFICATION_MESSAGE_FIND_ALL,
  API_NOTIFICATION_MESSAGE_FIND_ONE,
  API_NOTIFICATION_MESSAGE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { NotificationMessageDto } from '../dto';
import { FindAllResponse } from '../types';

export class NotificationMessageApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<NotificationMessageDto>> {
    return this.httpClient
      .get(API_NOTIFICATION_MESSAGE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(NotificationMessageDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<NotificationMessageDto> {
    return this.httpClient
      .get(API_NOTIFICATION_MESSAGE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(NotificationMessageDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<NotificationMessageDto> {
    return this.httpClient
      .post(API_NOTIFICATION_MESSAGE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(NotificationMessageDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<NotificationMessageDto> {
    return this.httpClient
      .put(API_NOTIFICATION_MESSAGE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(NotificationMessageDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_NOTIFICATION_MESSAGE_DELETE, {
      pathParams: { uuid }
    });
  }
}
